module.exports = __webpack_public_path__ + "img/flight-deck-gal-5.5ee5ddf7.jpg";